import { LoadablePaint } from '@confluence/loadable';

export const LazyCodeMacroConfigurationPage = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ConfigureCodeMacroContainer" */ '../src/ConfigureCodeMacro/ConfigureCodeMacroPage'
			)
		).ConfigureCodeMacroPage,
});
